import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  applyUserPolicy, consumeReload, flushRegistrationCompleted, initMetrica, setUserStatus, trackPageview,
} from "@/lib/metrica";

const PUBLIC_PATHS = ["/login", "/register"];

// Init + SPA pageview; yalnızca oturumsuz sayfalar ve trial kullanıcılar. Admin paneli izlenmez.
export default function MetricaTracker() {
  const location = useLocation();
  const { user } = useAuth();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return;
    const decision = applyUserPolicy(user);
    if (decision === "blocked") {
      // Giriş sayfasından uygulamaya geçince bir kez yenile → Webvisor kaydı tamamen durur.
      if (!PUBLIC_PATHS.includes(location.pathname) && consumeReload()) window.location.reload();
      return;
    }
    if (decision === "wait") return;
    initMetrica();
    trackPageview(location.pathname, location.search);
    if (user) {
      setUserStatus(user.subscription_status);
      if (!PUBLIC_PATHS.includes(location.pathname)) flushRegistrationCompleted();
    }
  }, [user, location.pathname, location.search, isAdmin]);

  return null;
}
